import React from 'react';
import { Input } from '../Input';
import { Select } from '../Select';
import { FormLabel } from '../FormLabel';

interface GroupedInputProps<T extends string> {
  label: string;
  value: string | number;
  units: T;
  options: readonly T[];
  onValueChange: (value: string | number) => void;
  onUnitsChange: (value: T) => void;
  error?: string;
  type?: 'text' | 'number';
  min?: number;
  required?: boolean;
  tooltip?: string;
}

export const GroupedInput = <T extends string>({
  label,
  value,
  units,
  options,
  onValueChange,
  onUnitsChange,
  error,
  type = 'text',
  min,
  required,
  tooltip
}: GroupedInputProps<T>) => {
  return (
    <div className="flex flex-col gap-1">
      <FormLabel label={label} required={required} tooltip={tooltip} />
      <div className="flex gap-2">
        <div className="flex-1">
          <Input
            label=""
            value={value}
            onChange={onValueChange}
            type={type}
            min={min}
            error={error}
          />
        </div>
        <div className="w-32">
          <Select
            label=""
            value={units}
            onChange={onUnitsChange}
            options={options}
          />
        </div>
      </div>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
};